import React from "react";
import { Form, Checkbox } from "antd";

const Disciplinas = ({
    disciplinas,
    todasDisciplinas,
    indeterminate,
    handleChangeTodas,
    handleChangeSelectDisciplinas,
    disciplinasSelecionadas,
    getFieldDecorator
}) => (
    <Form.Item label="Disciplinas">
        <div style={{ marginBottom: "20px" }}>
            <Checkbox indeterminate={indeterminate} onChange={handleChangeTodas} checked={todasDisciplinas}>
                Todas
            </Checkbox>
        </div>
        {getFieldDecorator("disciplinasSelecionadas", {
            rules: [{ required: true, message: "Por favor, selecione ao menos uma disciplina!" }],
            initialValue: disciplinasSelecionadas
        })(
            <Checkbox.Group style={{ width: "100%" }} onChange={handleChangeSelectDisciplinas}>
                {disciplinas
                    .filter(d => d.visivel)
                    .map(disciplina => (
                        <div key={disciplina.id} style={{ marginBottom: "20px" }}>
                            <Checkbox value={disciplina.id}>{disciplina.nome}</Checkbox>
                        </div>
                    ))}
            </Checkbox.Group>
        )}
    </Form.Item>
);

export default Disciplinas;
